var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_66494)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    rx: 540,
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 0H0V1080H1080V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.138 756.429H335.357V321.9H429.116V672.216H745.138V756.384V756.429Z",
    fill: "#190066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.137 406.068C791.327 406.068 828.771 368.384 828.771 321.9C828.771 275.416 791.327 237.733 745.137 237.733C698.948 237.733 661.504 275.416 661.504 321.9C661.504 368.384 698.948 406.068 745.137 406.068Z",
    fill: "#190066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_66494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    rx: 540,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinea);
export default __webpack_public_path__ + "static/media/linea.a4009e6c0f7f19d4fca39f6ccc298ff4.svg";
export { ForwardRef as ReactComponent };